const translations = {
  en: {
    // Navigation
    home: 'Home',
    shop: 'Shop',
    sale: 'Sale',
    bestSeller: 'Best Seller',
    about: 'About',
    contact: 'Contact',
    admin: 'Admin',
    talkToUs: 'Talk to Us',
    logout: 'Logout',

    // Home
    heroTitle: 'Studio Crochet',
    heroSubtitle: 'Premium Ethnic Wear',
    shopNow: 'Shop Now',
    shopByCategory: 'Shop By Category',
    featuredCollection: 'Featured Collection',
    bestSellers: 'Best Sellers',
    viewAll: 'View All',
    followInstagram: 'Follow Us on Instagram',
    instagramDesc: 'See our latest collections, behind-the-scenes, and style inspiration on Instagram',
    instagramTag: 'Tag us in your Studio Crochet looks for a chance to be featured!',
    whatClientsSay: 'What Our Clients Say',

    // Shop
    shopAll: 'Shop All',
    filters: 'Filters',
    allCategories: 'All Categories',
    sortBy: 'Sort By',
    newest: 'Newest',
    priceLowHigh: 'Price: Low to High',
    priceHighLow: 'Price: High to Low',
    loading: 'Loading...',
    noProducts: 'No products found',

    // Product
    selectColor: 'Select Color',
    selectSize: 'Select Size',
    sizeChart: 'Size Chart',
    customNote: 'Custom Note (Optional)',
    customNotePlaceholder: 'Any custom requirements...',
    quantity: 'Quantity',
    inStock: 'In Stock',
    available: 'available',
    outOfStock: 'Out of Stock',
    addToCart: 'Add to Cart',
    buyNow: 'Buy Now',
    codAvailable: 'COD Available',
    youMayAlsoLike: 'You May Also Like',
    addedToCart: 'Added to cart',
    productNotFound: 'Product not found',
    onlyLeft: 'Only {count} left!',

    // Cart
    shoppingCart: 'Shopping Cart',
    cartEmpty: 'Your cart is empty',
    continueShopping: 'Continue Shopping',
    orderSummary: 'Order Summary',
    subtotal: 'Subtotal',
    shipping: 'Shipping',
    free: 'FREE',
    total: 'Total',
    proceedToCheckout: 'Proceed to Checkout',
    removedFromCart: 'Removed from cart',

    // Checkout
    checkout: 'Checkout',
    billingDetails: 'Billing Details',
    fullName: 'Full Name',
    phone: 'Phone',
    email: 'Email',
    shippingAddress: 'Shipping Address',
    city: 'City',
    state: 'State',
    pincode: 'Pincode',
    orderNotes: 'Order Notes (Optional)',
    orderNotesPlaceholder: 'Any special instructions for your order...',
    paymentMethod: 'Payment Method',
    payOnline: 'Pay Online (Razorpay)',
    payOnlineDesc: 'Cards, UPI, Netbanking, Wallets',
    payNow: 'Pay Now',
    placeOrder: 'Place Order',
    processing: 'Processing...',
    whatsappNote: 'By placing this order, you will be redirected to WhatsApp to confirm with our team.',
    paymentInINR: 'Payment will be processed in INR (₹{amount})',

    // Order Confirmation
    orderConfirmed: 'Order Confirmed!',
    thankYou: 'Thank you for shopping with Studio Crochet',
    orderId: 'Order ID',
    status: 'Status',
    paidViaRazorpay: 'Paid via Razorpay',
    itemsOrdered: 'Items Ordered',
    deliveryAddress: 'Delivery Address',
    orderTracking: 'Order Tracking',
    trackingMessage: 'Tracking details will be shared personally via WhatsApp or Email. Our team will reach out to you shortly.',
    confirmOnWhatsApp: 'Confirm Order on WhatsApp',
    forQueries: 'For any queries, contact us at',

    // Sale & Bestseller
    saleTitle: 'Sale',
    saleDesc: 'Exclusive discounts on premium ethnic wear',
    bestSellerTitle: 'Best Sellers',
    bestSellerDesc: 'Our most loved pieces',

    // About
    ourStory: 'Our Story',

    // Contact
    getInTouch: 'Get in Touch',
    contactInfo: 'Contact Information',
    address: 'Address',
    sendMessage: 'Send us a Message',
    yourName: 'Your Name',
    yourEmail: 'Your Email',
    yourPhone: 'Your Phone (optional)',
    yourMessage: 'Your Message',
    send: 'Send Message',
    sending: 'Sending...',

    // Footer
    quickLinks: 'Quick Links',
    categories: 'Categories',
    contactUs: 'Contact Us',
    premiumDesc: 'Premium ethnic wear for the modern woman',
    allRights: '© 2026 Studio Crochet by Ekta Singh. All rights reserved.',

    // Currency
    currency: 'Currency',
    language: 'Language',
  },

  ar: {
    // Navigation
    home: 'الرئيسية',
    shop: 'المتجر',
    sale: 'تخفيضات',
    bestSeller: 'الأكثر مبيعاً',
    about: 'من نحن',
    contact: 'اتصل بنا',
    admin: 'لوحة التحكم',
    talkToUs: 'تحدث إلينا',
    logout: 'تسجيل الخروج',

    // Home
    heroTitle: 'ستوديو كروشيه',
    heroSubtitle: 'أزياء عرقية فاخرة',
    shopNow: 'تسوقي الآن',
    shopByCategory: 'تسوقي حسب الفئة',
    featuredCollection: 'المجموعة المميزة',
    bestSellers: 'الأكثر مبيعاً',
    viewAll: 'عرض الكل',
    followInstagram: 'تابعينا على انستقرام',
    instagramDesc: 'شاهدي أحدث مجموعاتنا وإلهام الأزياء على انستقرام',
    instagramTag: 'ضعي إشارة لنا في إطلالاتك من ستوديو كروشيه لفرصة الظهور!',
    whatClientsSay: 'ماذا يقول عملاؤنا',

    // Shop
    shopAll: 'جميع المنتجات',
    filters: 'التصفية',
    allCategories: 'جميع الفئات',
    sortBy: 'الترتيب حسب',
    newest: 'الأحدث',
    priceLowHigh: 'السعر: من الأقل للأعلى',
    priceHighLow: 'السعر: من الأعلى للأقل',
    loading: 'جاري التحميل...',
    noProducts: 'لم يتم العثور على منتجات',

    // Product
    selectColor: 'اختاري اللون',
    selectSize: 'اختاري المقاس',
    sizeChart: 'جدول المقاسات',
    customNote: 'ملاحظة مخصصة (اختياري)',
    customNotePlaceholder: 'أي متطلبات خاصة...',
    quantity: 'الكمية',
    inStock: 'متوفر',
    available: 'متاح',
    outOfStock: 'غير متوفر',
    addToCart: 'أضيفي إلى السلة',
    buyNow: 'اشتري الآن',
    codAvailable: 'الدفع عند الاستلام متاح',
    youMayAlsoLike: 'قد يعجبك أيضاً',
    addedToCart: 'تمت الإضافة إلى السلة',
    productNotFound: 'المنتج غير موجود',
    onlyLeft: 'متبقي {count} فقط!',

    // Cart
    shoppingCart: 'سلة التسوق',
    cartEmpty: 'سلة التسوق فارغة',
    continueShopping: 'متابعة التسوق',
    orderSummary: 'ملخص الطلب',
    subtotal: 'المجموع الفرعي',
    shipping: 'الشحن',
    free: 'مجاني',
    total: 'المجموع',
    proceedToCheckout: 'المتابعة للدفع',
    removedFromCart: 'تمت الإزالة من السلة',

    // Checkout
    checkout: 'إتمام الشراء',
    billingDetails: 'تفاصيل الفاتورة',
    fullName: 'الاسم الكامل',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    shippingAddress: 'عنوان الشحن',
    city: 'المدينة',
    state: 'الولاية / الإمارة',
    pincode: 'الرمز البريدي',
    orderNotes: 'ملاحظات الطلب (اختياري)',
    orderNotesPlaceholder: 'أي تعليمات خاصة لطلبك...',
    paymentMethod: 'طريقة الدفع',
    payOnline: 'الدفع الإلكتروني (Razorpay)',
    payOnlineDesc: 'بطاقات، UPI، تحويل بنكي، محافظ إلكترونية',
    payNow: 'ادفعي الآن',
    placeOrder: 'تأكيد الطلب',
    processing: 'جاري المعالجة...',
    whatsappNote: 'بتأكيد الطلب، سيتم توجيهك إلى واتساب للتأكيد مع فريقنا.',
    paymentInINR: 'سيتم معالجة الدفع بالروبية الهندية (₹{amount})',

    // Order Confirmation
    orderConfirmed: 'تم تأكيد الطلب!',
    thankYou: 'شكراً لتسوقك مع ستوديو كروشيه',
    orderId: 'رقم الطلب',
    status: 'الحالة',
    paidViaRazorpay: 'تم الدفع عبر Razorpay',
    itemsOrdered: 'المنتجات المطلوبة',
    deliveryAddress: 'عنوان التوصيل',
    orderTracking: 'تتبع الطلب',
    trackingMessage: 'سيتم مشاركة تفاصيل التتبع شخصياً عبر واتساب أو البريد الإلكتروني. سيتواصل معك فريقنا قريباً.',
    confirmOnWhatsApp: 'تأكيد الطلب عبر واتساب',
    forQueries: 'لأي استفسارات، تواصلي معنا على',

    // Sale & Bestseller
    saleTitle: 'تخفيضات',
    saleDesc: 'خصومات حصرية على الأزياء العرقية الفاخرة',
    bestSellerTitle: 'الأكثر مبيعاً',
    bestSellerDesc: 'أكثر القطع المفضلة لدينا',

    // About
    ourStory: 'قصتنا',

    // Contact
    getInTouch: 'تواصلي معنا',
    contactInfo: 'معلومات الاتصال',
    address: 'العنوان',
    sendMessage: 'أرسلي لنا رسالة',
    yourName: 'الاسم',
    yourEmail: 'البريد الإلكتروني',
    yourPhone: 'الهاتف (اختياري)',
    yourMessage: 'رسالتك',
    send: 'إرسال',
    sending: 'جاري الإرسال...',

    // Footer
    quickLinks: 'روابط سريعة',
    categories: 'الفئات',
    contactUs: 'اتصلي بنا',
    premiumDesc: 'أزياء عرقية فاخرة للمرأة العصرية',
    allRights: '© 2026 ستوديو كروشيه بواسطة إيكتا سينغ. جميع الحقوق محفوظة.',

    // Currency
    currency: 'العملة',
    language: 'اللغة',
  },
};

export default translations;
